module.exports = __webpack_public_path__ + "img/WechatAccount.237962d6.png";